
define('jst!shared/_modal_ok_cancel_footer',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="ok-cancel-footer">\n  <%- button(t(\'Done\'), \'\', { \'class\': \'close-button done-button\', \'color\': \'primary\' }) %>\n  <%- button(t(\'Cancel\'), \'\', { \'class\': \'close-button cancel-button\', \'color\': \'secondary\' }) %>\n</div>\n');
 });

